import { createFileRoute, redirect } from '@tanstack/react-router';
import { FormPageTemplatePending } from '@/components/v2/page-template-pending';

// Writing a review needs a session; see the studio counterpart for why the guard
// lives on the route instead of the layout.
export const Route = createFileRoute('/_public/instructors/$instructorId/reviews/new')({
  // Form-shaped pending while the lazy chunk downloads; title matches the page
  // the route becomes (aria-labelled, kept out of the visual tree as a block).
  pendingComponent: () => <FormPageTemplatePending title="Write your review" cta />,
  beforeLoad: ({ context, location }) => {
    if (context.authState === 'unauthenticated') {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
});
